export const {
  REACT_APP_USER,
  REACT_APP_AUTH,
  REACT_APP_BASE_URL,
  REACT_APP_SUFFIX_BASE_URL,
  REACT_APP_CART,
  REACT_APP_KEY_CRIPTO,
  REACT_APP_IV_CRIPTO,
  REACT_APP_PAGSEGURO_ENV,
  REACT_APP_PAGSEGURO_TOKEN,
  REACT_APP_BIOMETRIC_KEY,
} = process.env;
